import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { NzModalRef, NzMessageService } from 'ng-zorro-antd';
import * as moment from 'moment';

import { Store, ModelService } from 'src/app/common';
import { ProjectModel } from '../../models/project.model';

@Component({
  selector: "createProjectModal",
  templateUrl: "./createProject.html"
})
export class CreateProjectModal {

  public edit: boolean = false;

  public isLoading: boolean = false;

  public form: FormGroup;

  public store: Store<ProjectModel>;

  public model: ProjectModel;

  public clientId: number;

  constructor(private modal: NzModalRef,
              private modelService: ModelService,
              private message: NzMessageService,
              private ts: TranslateService,
              private fb: FormBuilder,) {

    this.store = this.modelService.getStore('ProjectModel');
    this.createForm();

    setTimeout(() => {
      if(this.model !== undefined){
        this.edit = true;
        this.fillForm();
      }else{
        this.model = new ProjectModel({
          client: {id: this.clientId}
        });
      }
    }, 0);
  }

  private createForm(): void {
		this.form = this.fb.group({
      name: ['', Validators.required],
      description: [''],
      startDate: [moment().toDate(), Validators.required],
      endDate: [null]
		});
  }

  private fillForm(): void {
		this.model.populateFormWihtModel(this.form);
  }

  private destroyModal(success: boolean): void {
    this.modal.destroy({data: success});
  }

  public onCancelClick(): void {
    this.destroyModal(false);
  }

  public onSubmitClick(): void {
    this.form.controls.name.setValue(this.form.value.name.trim());
    this.form.controls.description.setValue(this.form.value.description.trim());

    for (const i in this.form.controls) {
      this.form.controls[i].markAsDirty();
      this.form.controls[i].updateValueAndValidity();
    }
    if (!this.form.valid) return;

    this.edit ? this.update() : this.create();
  }

  private create(): void {
    this.isLoading = true;

    this.model.populateModelWithForm(this.form);
    this.store.create(this.model).subscribe((res) => {
      this.isLoading = false;
      if(res){
        this.message.success(this.ts.instant('drone.createProjectModal.create.succesMsg'));
        this.destroyModal(true);
      }else{
        this.message.error(this.ts.instant('drone.createProjectModal.create.errorMsg'));
      }
    });
  }

  private update(): void {
    this.isLoading = true;

    this.model.populateModelWithForm(this.form);
    this.store.update(this.model).subscribe((res) => {
      this.isLoading = false;
      if(res){
        this.message.success(this.ts.instant('drone.createProjectModal.update.succesMsg'));
        this.destroyModal(true);
      }else{
        this.message.error(this.ts.instant('drone.createProjectModal.update.errorMsg'));
      }
    });
  }
}
